import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'
import { string } from 'yup';

export interface Hotel {
  _id: string;
  name: string;
  hotel_id: string;
  image: Image; // Added image field
}
export interface Translation {
  description:string;
  language:string;
  name:string;
}
export interface Image {
  _id: string;
  url: string;
  seoUrl: string;
  __v: number;
}

export interface PaymentMethod {
  _id: string;
  code: string;
  description: string;
  isActive: boolean;
  translations: Translation[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface Reservation {
  _id?: ID;
  hotel: Hotel;
  paymentMethod: PaymentMethod;
  checkInDate: string;
  checkOutDate: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  bookingId: number;
  idLog: string;
  totalPrice: number;
  totalToPay: number;
}



export const initialReservation: Reservation = {
  hotel: {
    _id: '',
    name: '',
    hotel_id: '',
    image: { 
      _id: '',
      url: '',
      seoUrl: '',
      __v: 0,
    },
  },
  paymentMethod: {
    _id: '',
    code: '',
    description: '',
    isActive: true,
    translations: [],
    createdAt: '',
    updatedAt: '',
    __v: 0
  },
  checkInDate: '',
  checkOutDate: '',
  createdAt: '',
  updatedAt: '',
  __v: 0,
  bookingId: 0,
  idLog: '',
  totalPrice: 0,
  totalToPay: 0

};
export type ReservationsQueryResponse = Response<Array<Reservation>>;
export type QueryResponseReservationContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createReservationResponseContext<T>(initialState: QueryResponseReservationContextProps<T>) {
  return createContext(initialState)
}
export const initialReservationQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }